import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'
import { faFacebook, faQq, faWeixin, faWeibo, faGoogle } from '@fortawesome/free-brands-svg-icons'
import {
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faArrowLeft,
  faArrowRight,
  faAward,
  faBars,
  faBell,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faDollarSign,
  faEnvelope,
  faEye,
  faExclamationTriangle,
  faGamepad,
  faGift,
  faGrinTongueWink,
  faGrinWink,
  faHandshake,
  faInfoCircle,
  faLaugh,
  faLightbulb,
  faMobileAlt,
  faPencilAlt,
  faPlay,
  faPlane,
  faPlus,
  faSearch,
  faSignInAlt,
  faStar,
  faUser,
  faUsers,
  faTimes,
  faTrashAlt,
  faTrophy,
  faUmbrellaBeach,
  faUnlockAlt,
} from '@fortawesome/free-solid-svg-icons'

import {
  faClock,
  faCopy,
  faFutbol,
  faGem,
} from '@fortawesome/free-regular-svg-icons'

library.add(
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faArrowLeft,
  faArrowRight,
  faAward,
  faBars,
  faBell,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faClock,
  faCopy,
  faDollarSign,
  faEnvelope,
  faEye,
  faExclamationTriangle,
  faFacebook,
  faFutbol,
  faGamepad,
  faGem,
  faGift,
  faGrinTongueWink,
  faGrinWink,
  faGoogle,
  faHandshake,
  faInfoCircle,
  faLaugh,
  faLightbulb,
  faMobileAlt,
  faQq,
  faPencilAlt,
  faPlay,
  faPlane,
  faPlus,
  faSearch,
  faSignInAlt,
  faStar,
  faWeibo,
  faWeixin,
  faUser,
  faUsers,
  faTimes,
  faTrashAlt,
  faTrophy,
  faUmbrellaBeach,
  faUnlockAlt,
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
